<template>
  <div class="hello">
    <div ref="editor" class="editor"></div>
    <wt-button wide @click="evaluateCode">Evaluate!</wt-button>
    <wt-button color="secondary" wide @click="log">Log to console</wt-button>
  </div>
</template>

<script>
import CodeFlask from 'codeflask';

export default {
  name: 'HelloWorld',
  data: () => ({
    editor: null,
    code: `

      const script = document.createElement('script');
      script.src = 'https://dev.webitel.com/omni-widget/WtOmniWidget.umd.js';
      script.onload = function () {
        const body = document.querySelector('body');
        const widgetEl = document.createElement('div');
        widgetEl.setAttribute('id', 'wt-omnichannel-widget');
        body.appendChild(widgetEl);

        const config = {
    "view": {
        "lang": "en"
    },
    "chat": {
        "url": "wss://dev.webitel.com/chat/dania-webchat"
    },
    "appointment": {
        "showEmailField": true,
        "showMessageField": true,
        "url": "https://dev.webitel.com/appointments/dania-webchat"
    }
};

        const app = new WtOmniWidget('#wt-omnichannel-widget', config);
      };
      document.head.appendChild(script);

      const link = document.createElement('link');
      link.href = 'https://dev.webitel.com/omni-widget/WtOmniWidget.css';
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.media = 'screen,print';
      document.head.appendChild(link);

    `,
  }),
  methods: {
    evaluateCode() {
      const widget = document.getElementById('wt-omnichannel-widget');
      if (widget) widget.remove();

      // eslint-disable-next-line no-eval
      eval(this.code);
    },
    initEditor() {
      this.editor = new CodeFlask(this.$refs.editor, { language: 'js' });
      this.editor.updateCode(this.code);

      this.editor.onUpdate((code) => {
        this.code = code;
      });
    },
    log() {
      console.log(this.code);
    },
  },
  watch: {
    code(value) {
      if (this.editor) {
        this.editor.updateCode(value);
      }
    },
  },
  mounted() {
    this.initEditor();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.hello {
  padding: 10px;

  .editor {
    position: relative;
    width: 100%;
    height: 70vh;
  }

  .wt-button {
    margin-top: 10px;
  }
}
</style>
